import Chip from "@mui/material/Chip";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import clsx from "clsx";
import style from "./drop-down-deadline-select.module.scss";
import { useState } from "react";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

type deadlinesType = {
  id: string;
  title: string;
  color: string;
};

type PropsDropDownDeadlineSelect = {
  type: string;
  title: string;
  handlerChangeFilter: (key: string, value: number[]) => void;
};

export const DropDownDeadlineSelect: React.FC<PropsDropDownDeadlineSelect> = ({
  handlerChangeFilter,
  title,
  type,
}) => {
  const [ids, setIds] = useState<deadlinesType[]>([]);

  const onChange = (event: any, value: deadlinesType[]) => {
    handlerChangeFilter(
      type,
      value.map((v) => v.id.split(",").map((v) => parseInt(v))).flat()
    );
    return setIds(value);
  };

  const handleSelectClose = () => {
    handlerChangeFilter(
      type,
      ids.map((v) => v.id.split(",").map((v) => parseInt(v))).flat()
    );
  };

  return (
    <div className={style.container}>
      <Autocomplete
        multiple
        fullWidth
        disableCloseOnSelect
        size="small"
        options={deadlines.slice(1)}
        limitTags={1}
        getOptionLabel={(option) => option.title}
        value={ids
          .filter((e) => !!deadlines.slice(1).find((f) => f.id === e.id))
          .map(
            (e) =>
              deadlines.slice(1).find((f) => f.id === e.id) as deadlinesType
          )}
        onChange={onChange}
        onClose={handleSelectClose}
        noOptionsText={"Нет совпадений"}
        slotProps={{
          listbox: {
            sx: {
              padding: "0",
            },
          },
          popper: {
            popperOptions: {
              placement: "bottom-start",
            },
            sx: {
              width: "auto !important",
              maxWidth: "30vw",
            },
          },
        }}
        renderTags={(value: deadlinesType[], getTagProps) =>
          value.map((option: deadlinesType, index: number) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                variant="outlined"
                size="small"
                label={option.title}
                key={key}
                {...tagProps}
              />
            );
          })
        }
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={option.id} {...optionProps} className={style.checked_list}>
              <div className={style.checked_row}>
                <Checkbox
                  checked={selected}
                  name="select_all"
                  color="primary"
                  icon={icon}
                  checkedIcon={checkedIcon}
                />
                <span>{option.title}</span>
              </div>
              <div
                className={clsx(
                  style.block_color,
                  style[`block_color_${option.color}`]
                )}
              ></div>
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            label={title}
            placeholder="Введите значение"
            className={style.box_input}
          />
        )}
      />
    </div>
  );
};

const deadlines: deadlinesType[] = [
  {
    id: "0",
    title: "Выбрать...",
    color: "",
  },
  {
    id: "-2147483648,0",
    title: "Просроченные",
    color: "red-row",
  },
  {
    id: "0,14",
    title: "2 недели до окончания",
    color: "red-row",
  },
  {
    id: "15,30",
    title: "1 месяц до окончания",
    color: "orange-row",
  },

  {
    id: "31,60",
    title: "2 месяца до окончания",
    color: "yellow-row",
  },

  {
    id: "61,2147483647",
    title: "Свыше 2-х месяцев",
    color: "green-row",
  },
];
